const submitBlindForm = ({data, route}) => {
  const form = document.createElement('form')
  const node = document.createElement('input')
  form.action = route
  form.method = 'post'
  data.forEach(({key, value}) => {
    node.name = key
    node.value = value.toString()
    form.appendChild(node.cloneNode())
  })
  form.style.display = 'none'
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}

export default submitBlindForm
